angular
	.module 'App.Repository'
	.factory 'RightRepository', ['BaseRepository', (BaseRepository) ->
		class RightRepository extends BaseRepository
			@resource = '/rights'
			@isRestricted = true

		return new RightRepository
	]
